export default __webpack_public_path__ + "static/media/Exhaust.1c33ad95.jpg";